import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHardHat, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import styles from '../../pages/Dashboard.module.css';

const TimesheetChantierView = ({
    groupedByChantier,
    getHoursColor,
    handleEdit,
    handleDelete
}) => {
    return (
        <div>
            {Object.entries(groupedByChantier).map(([chantierName, data]) => (
                <div key={chantierName} style={{
                    marginBottom: '2rem',
                    background: 'var(--color-surface)',
                    borderRadius: 'var(--border-radius-lg)',
                    padding: '1.5rem',
                    boxShadow: 'var(--shadow-light)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '20px' }}>
                        <div>
                            <h3 style={{ margin: '0 0 5px', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.3rem' }}>
                                <FontAwesomeIcon icon={faHardHat} style={{ color: 'var(--color-primary)' }} />
                                {chantierName}
                            </h3>
                            <div style={{ fontSize: '0.9rem', color: '#64748b' }}>
                                Suivi des heures et rentabilité
                            </div>
                        </div>

                        {/* Statut des Heures (Remplace les infos financières) */}
                        <div style={{ display: 'flex', gap: '15px' }}>
                            {(() => {
                                const approvedHours = data.entries
                                    .filter(e => e.status === 'approved')
                                    .reduce((sum, e) => sum + (e.hours || 0), 0);
                                const pendingHours = data.entries
                                    .filter(e => ['pending', 'pending_manager', 'pending_rh'].includes(e.status))
                                    .reduce((sum, e) => sum + (e.hours || 0), 0);
                                const rejectedHours = data.entries
                                    .filter(e => ['rejected', 'litige'].includes(e.status))
                                    .reduce((sum, e) => sum + (e.hours || 0), 0);
                                
                                const workerStats = {};
                                data.entries.forEach(e => {
                                    const name = e.expand?.worker?.name || e.expand?.worker?.username || 'Inconnu';
                                    workerStats[name] = (workerStats[name] || 0) + (e.hours || 0);
                                });
                                const workerStatsArray = Object.entries(workerStats).sort((a, b) => b[1] - a[1]);

                                return (
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', gap: '15px', marginBottom: '1rem', flexWrap: 'wrap' }}>
                                            <div style={{ background: '#f8fafc', padding: '10px 15px', borderRadius: '8px', border: '1px solid #e2e8f0', minWidth: '130px' }}>
                                                <div style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px' }}>Total Heures Effectuées</div>
                                                <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#334155' }}>
                                                    {data.totalHours}h
                                                </div>
                                            </div>
                                            <div style={{ background: '#f0fdf4', padding: '10px 15px', borderRadius: '8px', border: '1px solid #dcfce7', minWidth: '130px' }}>
                                                <div style={{ fontSize: '0.8rem', color: '#166534', marginBottom: '4px' }}>Heures Validées</div>
                                                <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#15803d' }}>
                                                    {approvedHours}h
                                                </div>
                                            </div>
                                            <div style={{ background: '#fffbeb', padding: '10px 15px', borderRadius: '8px', border: '1px solid #fef3c7', minWidth: '130px' }}>
                                                <div style={{ fontSize: '0.8rem', color: '#b45309', marginBottom: '4px' }}>En Attente</div>
                                                <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#d97706' }}>
                                                    {pendingHours}h
                                                </div>
                                            </div>
                                            {rejectedHours > 0 && (
                                                <div style={{ background: '#fef2f2', padding: '10px 15px', borderRadius: '8px', border: '1px solid #fee2e2', minWidth: '130px' }}>
                                                    <div style={{ fontSize: '0.8rem', color: '#991b1b', marginBottom: '4px' }}>Refusées / Litige</div>
                                                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#dc2626' }}>
                                                        {rejectedHours}h
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ fontSize: '0.85rem', color: '#64748b', background: '#f1f5f9', padding: '8px 12px', borderRadius: '6px' }}>
                                            <strong>Répartition :</strong> {workerStatsArray.map(([name, hrs]) => `${name} (${hrs}h)`).join(' • ')}
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                    <table className={styles.dataTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Employé</th>
                                <th>Heures</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.entries.map(entry => (
                                <tr key={entry.id}>
                                    <td>{new Date(entry.date).toLocaleDateString('fr-FR')}</td>
                                    <td>{entry.expand?.worker?.name || entry.expand?.worker?.username || 'Inconnu'}</td>
                                    <td>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: getHoursColor(entry.hours),
                                            padding: '4px 8px',
                                            background: getHoursColor(entry.hours) + '15',
                                            borderRadius: '6px'
                                        }}>
                                            {entry.hours}h
                                        </span>
                                    </td>
                                    <td style={{ color: 'var(--color-text-light)', fontStyle: 'italic' }}>
                                        {entry.description || '-'}
                                    </td>
                                    <td className={styles.actions}>
                                        <button className={styles.edit} onClick={() => handleEdit(entry)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className={styles.delete} onClick={() => handleDelete(entry.id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
            {Object.keys(groupedByChantier).length === 0 && (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                    Aucune donnée à afficher
                </div>
            )}
        </div>
    );
};

export default TimesheetChantierView;
